export enum CourseParticipantsMutations {
  RESET = "RESET",
  SET_PERSON = "SET_PERSON",
  SET_STUDENTS = "SET_STUDENTS",
  ADDED = "ADDED",
}
